import { ITableColumn, TableColumnTypeEnum, WidthType } from './tableColumn.interface';

export const EffectivePolicySettingsColumn: ITableColumn[] = [
  {
    labelPath: 'policyPage.config.generalSettingsContent.effectivePolicySettingsRuleName',
    propertyKey: 'ruleName',
    tooltipDynamicText: 'ruleName',
    colType: TableColumnTypeEnum.InternalNavigation,
    width: 80,
    widthType: WidthType.Percentage,
  },
  {
    labelPath: 'policyPage.config.generalSettingsContent.effectivePolicySettingsRuleId',
    propertyKey: 'ruleId',
    colType: TableColumnTypeEnum.CopyableText,
    width: 22,
    widthType: WidthType.Percentage,
    isSortable: false,
  },
];
